import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { withDefaults } from 'vue';
import _ from 'lodash';

import SuccessModal from '@/components/modals/SuccessModal.vue';
import WarningModal from '@/components/modals/WarningModal.vue';
import InfoModal from '@/components/modals/InfoModal.vue';
import SpinningLoaderInline from '@/components/modals/SpinningLoaderInline.vue';

import { EUpdateStates } from '@/aux/enums';

import { TuseAPIResult } from '@/composables/useAPI';

interface Props {
  modelValue: TuseAPIResult;
  loadingMessage?: string;
  showSuccess?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'APIDataResult',
  props: {
    modelValue: null,
    loadingMessage: { default: 'Loading' },
    showSuccess: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: TuseAPIResult, loadingMessage: string, showSuccess: boolean };





const handleSuccessReset = () => {
  const newModalValue = _.cloneDeep(props.modelValue);

  newModalValue.state = EUpdateStates.NO;

  emit('update:modelValue', newModalValue);
};

const handleErorrReset = (index: number) => {
  const newModalValue = _.cloneDeep(props.modelValue);

  newModalValue.errors.splice(index, 1);

  emit('update:modelValue', newModalValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InfoModal, {
      active: __props.modelValue.state === _unref(EUpdateStates).PROGRESS
    }, {
      default: _withCtx(() => [
        _createVNode(SpinningLoaderInline, { spinner_text: __props.loadingMessage }, null, 8, ["spinner_text"])
      ]),
      _: 1
    }, 8, ["active"]),
    (__props.showSuccess)
      ? (_openBlock(), _createBlock(SuccessModal, {
          key: 0,
          active: __props.modelValue.state === _unref(EUpdateStates).SUCCESS,
          onReset: handleSuccessReset
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "successMessage", {}, () => [
              _createTextVNode("Success!")
            ])
          ]),
          _: 3
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.errors, (error, index) => {
      return (_openBlock(), _createBlock(WarningModal, {
        key: index,
        active: true,
        onReset: (index) => handleErorrReset(index)
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", { innerHTML: error }, null, 8, _hoisted_1)
        ]),
        _: 2
      }, 1032, ["onReset"]))
    }), 128))
  ], 64))
}
}

})